var map = {
	"./ear_32x32_white.svg": "ad99",
	"./icon-call.svg": "0c41",
	"./icon-hangout.svg": "8fa7",
	"./icon-mail.svg": "9409",
	"./icon-messenger.svg": "37f2",
	"./icon-money.svg": "0f17",
	"./icon_ondivan_red.svg": "beea",
	"./icon_ondivan_white.svg": "9cf8",
	"./logo-skype.svg": "83ab",
	"./logo-whatsapp.svg": "a4b3",
	"./logo.svg": "9b19",
	"./md-star.svg": "ebc6",
	"./ondivan_marca_red.svg": "30c3",
	"./ondivan_marca_white.svg": "62f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";